import { Grid } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { IProjectDTO } from 'data/dtos/automation/i-project-dto'
import CardSkelleton from 'pages/automation/project/list/card-skelleton'
import { loadList } from 'services/requests'
import useContract from 'store/contracts'
import ContractToolsCard from './card'
import { useStyles } from './styles'

const ContratcsTools = () => {
  const { actualOrganization } = useContract()
  const classes = useStyles()

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['contract', 'tool', 'list', actualOrganization],
    queryFn: () =>
      loadList('/projects/list', {
        search: '',
        page: 0,
        rowsPerPage: 1000,
        columnOrder: [],
        organizationId: actualOrganization.id,
      }),
    initialData: { data: { data: [] } } as any,
  })

  if (isLoading || isFetching) {
    return (
      <div className={classes.root}>
        <Grid
          container
          spacing={3}
          className={classes.itemList}
        >
          <CardSkelleton />
          <CardSkelleton />
          <CardSkelleton />
          <CardSkelleton />
          <CardSkelleton />
          <CardSkelleton />
          <CardSkelleton />
          <CardSkelleton />
          <CardSkelleton />
          <CardSkelleton />
          <CardSkelleton />
          <CardSkelleton />
        </Grid>
      </div>
    )
  }

  const projects: IProjectDTO[] = data?.data.data.filter((project: IProjectDTO) => project.contractName === '')

  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={3}
        className={classes.itemList}
      >
        {projects.map((project) => (
          <Grid
            key={project?.id}
            item
            xs={6}
          >
            <ContractToolsCard project={project} />
          </Grid>
        ))}
      </Grid>
    </div>
  )
}

export default ContratcsTools
